import { optionalPositiveInteger, optionalTrimmedString } from '../../../lib/routeSearch';
import {
  defaultStitcherAccessFilter,
  StitcherAccessFilter,
  stitcherAccessPageSizes,
  type StitcherAccessFilterValue,
} from './model';

export interface StitcherAccessRouteSearch {
  search?: string;
  access?: StitcherAccessFilter;
  page?: number;
  size?: number;
}

const stitcherAccessFilters: ReadonlySet<string> = new Set(Object.values(StitcherAccessFilter));
const stitcherAccessPageSizeValues: ReadonlySet<number> = new Set(stitcherAccessPageSizes);

export function stitcherAccessRouteSearchSchema(
  search: Record<string, unknown>,
): StitcherAccessRouteSearch {
  const searchTerm = optionalTrimmedString(search['search']);
  const rawAccess = optionalTrimmedString(search['access']);
  const access =
    rawAccess && stitcherAccessFilters.has(rawAccess)
      ? (rawAccess as StitcherAccessFilter)
      : undefined;
  const page = optionalPositiveInteger(search['page']);
  const rawSize = optionalPositiveInteger(search['size']);
  const size = rawSize && stitcherAccessPageSizeValues.has(rawSize) ? rawSize : undefined;
  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(access ? { access } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
  };
}

export function parseStitcherAccessRouteSearch(
  search: StitcherAccessRouteSearch,
): StitcherAccessFilterValue {
  return {
    searchTerm: search.search ?? defaultStitcherAccessFilter.searchTerm,
    access: search.access ?? defaultStitcherAccessFilter.access,
    page: search.page ? search.page - 1 : defaultStitcherAccessFilter.page,
    size: search.size ?? defaultStitcherAccessFilter.size,
  };
}

export function serializeStitcherAccessRouteSearch(
  filter: StitcherAccessFilterValue,
): StitcherAccessRouteSearch {
  const trimmedSearch = filter.searchTerm.trim();
  return {
    ...(trimmedSearch ? { search: trimmedSearch } : {}),
    ...(filter.access !== defaultStitcherAccessFilter.access ? { access: filter.access } : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultStitcherAccessFilter.size ? { size: filter.size } : {}),
  };
}
